// extracted by mini-css-extract-plugin
module.exports = {"small":"TotalItemsLegacy_small__H8eYO","large":"TotalItemsLegacy_large__8WAur"};